import classNames from 'classnames';
import { ReactNode, useCallback, useMemo } from 'react';

// import useKeyBoardKeys, { KEYS } from '../../hooks/useKeyboard';

import { useThemeClassName } from '../../contexts/ThemeContext';
import Button from '../buttons/Button';
// import { getDisplayName } from '../lib/utils';
import Portal from './Portal';

import styles from '../../../styles/modals/modal.module.scss';

interface ModalProps {
    id?: string;
    title?: string;
    position?: 'center' | 'top';
    opened?: boolean;
    withSafe?: boolean;
    onClickSafe?: () => void;
    // onClose?: () => void;
    onClosed?: () => void;
    children?: ReactNode;
}

const Modal = ({
    id = null,
    title = null,
    position = 'center',
    opened = true,
    withSafe = false,
    onClickSafe = null,
    // onClose = null,
    onClosed = null,
    children = null,
}: ModalProps) => {
    const finalId = useMemo(
        () => id /* || getDisplayName(children.type) */,
        [id /* , children.type */],
    );
    const data = useMemo(() => ({ title }), [title]);
    const themeClassName = useThemeClassName(styles);

    const onTransitionEnd = useCallback(() => {
        if (!opened && onClosed !== null) {
            onClosed();
        }
    }, [opened, onClosed]);

    const onSafeClick = useCallback(() => {
        if (onClickSafe !== null) {
            onClickSafe();
        }
    }, [onClickSafe]);

    // useKeyBoardKeys({
    //     [KEYS.ESCAPE]: onClose !== null ? onClose : null,
    // });

    return (
        <Portal id={finalId} data={data}>
            <div
                className={classNames([
                    styles.container,
                    themeClassName,
                    {
                        [styles[position]]: position !== null,
                        [styles.closing]: !opened,
                        [styles.withoutSafeClick]: onClickSafe === null,
                    },
                ])}
            >
                {withSafe ? <Button className={styles.safe} onClick={onSafeClick} /> : null}
                <div className={classNames([styles.inner])} onTransitionEnd={onTransitionEnd}>
                    {children}
                </div>
            </div>
        </Portal>
    );
};

export default Modal;
